import { IchraSignupComponentKey, RoutesMapping, SectionType } from 'adminSignUp'

import { ichraTaxClassificationApi } from 'core'
import { TaxClassificationValues } from 'core/application/adminSignUp/common/models'
import { ProductIds } from 'core/application/commons/config'
import { CompanyType } from 'core/domain/benefit/companyType'

import { BaseNavigationProps } from 'common/wizard/BaseNavigationProps'

import TaxClassification from '../../common/TaxClassification'

const IchraTaxClassification = (props: BaseNavigationProps<TaxClassificationValues>) => {
  const ichraSteps = RoutesMapping.get(ProductIds.IchraId).filter((i) => i.sectionType === SectionType.COMPANY_DETAILS)

  return (
    <TaxClassification
      descriptionMap={descriptionMap}
      companyTypeId={props.state.companyTypeId}
      taxClassificationApi={ichraTaxClassificationApi}
      numberOfQuestions={ichraSteps.length}
      currentQuestion={ichraSteps.findIndex((i) => i.key === IchraSignupComponentKey.TAX_CLASSIFICATION) + 1}
      {...props}
    />
  )
}

export default IchraTaxClassification

const descriptionMap = (translate: any): Map<number, string> =>
  new Map<number, string>([
    [
      CompanyType.CCorpNonProfitOrMunicipality,
      'C-corp owners are fully eligible to participate in the ICHRA provided that they are also qualifying W-2 employees.',
    ],
    [
      CompanyType.Scorp,
      'S-corp owners are not eligible to participate in the ICHRA. This is also true for the owner’s legal spouse, parents, children, and grandchildren.',
    ],
    [
      CompanyType.Partnership,
      'Owners of a partnership are not eligible for the ICHRA, however, an owner’s legal spouse who is a qualified W-2 employee of the company and is not a business partner is eligible.',
    ],
    [
      CompanyType.SoleProprietors,
      'Sole proprietors are not eligible to participate in the ICHRA, however, an owner’s legal spouse who is a W-2 employee of the company is eligible.',
    ],
    [
      CompanyType.LLCFilingAsSCorp,
      'Owners of an LLC filing as an S-corp are not eligible for the ICHRA. This is also true for the owner’s legal spouse, parents, children, and grandchildren.',
    ],
    [
      CompanyType.LLCFilingAsPartnership,
      'Owners of an LLC filing as a partnership are not eligible for the ICHRA, however, an owner’s legal spouse who is also a W-2 employee of the company and is not a business partner is eligible.',
    ],
  ])
